import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { ClearStagedListings } from '../../graphql/mutations';
import { ProgressBarsQuery, StagedListingSummaryByCatalogQuery, StagedListingSummaryQuery } from '../../graphql/queries';
import routePaths from '../../route-paths';
import { TitleService } from '../../services';
import { Breadcrumbs } from '../../store';
import GenericStaging from './generic-staging';

const Staging = ({ match, ...rest }) => {
  useEffect(() => {
    TitleService.setTitles('Staged Listings Overview');
    Breadcrumbs.set([
      {
        url: match.url,
        title: 'Staging',
      },
    ]);
  }, [match.url]);

  return (
    <GenericStaging
      key="Staging"
      dataTableProfileName="Staging"
      dataQuery={StagedListingSummaryQuery}
      progressBarsQuery={ProgressBarsQuery}
      dataGetter={(data) => data?.currentUserQuery?.stagedListingSummary || []}
      pollQuery={StagedListingSummaryByCatalogQuery}
      pollDataGetter={(data) => data?.currentUserQuery?.stagedListingSummaryByCatalog || []}
      refetchQueries={['StagedListingSummaryWithSiteQuery', 'StagedListingSummaryQuery', 'ProgressBarsQuery']}
      publishEndpoint="bid-sheet"
      clearListingsMutation={ClearStagedListings}
      clearListingsResponseGetter={(response) => response.data.clearStagedListings}
      detailPagePath={routePaths.staging}
      {...rest}
    />
  );
};

Staging.propTypes = {
  user: PropTypes.object,
  match: PropTypes.object,
  history: PropTypes.object,
};

export default Staging;
